var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"expanded":_vm.expanded,"item-key":"id","show-expand":""},on:{"update:expanded":function($event){_vm.expanded=$event}},scopedSlots:_vm._u([{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
var item = ref.item;
return [_c('td',{staticClass:"text-center",attrs:{"colspan":headers.length}},[_c('v-icon',[_vm._v("mdi-lock-outline")]),_vm._v(" "+_vm._s(item.description)+" ")],1)]}},{key:"item.data-table-expand",fn:function(ref){
var item = ref.item;
var isExpanded = ref.isExpanded;
return [_c('v-icon',[_vm._v(" "+_vm._s(isExpanded ? 'mdi-lock-outline' : '')+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }